exports.onRouteUpdate = (location) => {
  // console.warn("[gatsby-broswer] onRouteUpdate", location);
  if (location.hash) {
    setTimeout(() => {
      let section = document.querySelector(`${location.hash}`);
      // console.log("[gatsby-broswer] section", section);
      section.scrollIntoView();
    }, 0);
  }
};



/** WEBPACK FOOTER **
 ** ../gatsby-browser.js
 **/